'use strict'

import mime from 'mime-types'

export class DownloadService {
  constructor($http, $mdToast, $timeout, Blob, FileSaver) {
    'ngInject'
    Object.assign(this, { $http, $mdToast, $timeout, Blob, FileSaver })
  }

  /**
   * Save file via Blob.
   * @param fileName
   * @param data
   * @param headers
   */
  saveFile(fileName, data, headers) {
    const file = new this.Blob([data], { type: headers('Content-type') })
    this.FileSaver.saveAs(file, fileName)
  }

  /**
   * Handle download errors. Shows toast.
   * @param file
   */
  handleError(fileName) {
    const toast = this.$mdToast
      .simple()
      .textContent('Download von ' + fileName + ' fehlgeschlagen.')
      .position('bottom')
      .hideDelay(5000)
    this.$mdToast.show(toast)
  }

  getDocumentPdf(companyId, ref, fileName) {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + companyId + '/downloads/pdf',
      responseType: 'arraybuffer',
      params: { ref },
    })
      .success((data, status, headers) => this.saveFile(fileName + '.pdf', data, headers, 'pdf'))
      .error(() => this.handleError(fileName))
  }

  getDocumentZip(companyId, ref, fileName) {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + companyId + '/downloads/zip',
      responseType: 'arraybuffer',
      params: { ref },
    })
      .success((data, status, headers) => this.saveFile(fileName + '.zip', data, headers))
      .error(() => this.handleError(fileName))
  }

  getReport(companyId, customerId, reportId, fileName) {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + companyId + '/customers/' + customerId + '/reports/' + reportId,
      responseType: 'arraybuffer',
    })
      .success((data, status, headers) => {
        const suffix = mime.extension(headers('Content-type'))
        return this.saveFile(fileName + '.' + suffix, data, headers)
      })
      .error(() => this.handleError(fileName))
  }
}



// WEBPACK FOOTER //
// ./app/shared/services/download.service.js